const voice = {
  init: init,
  playOk: playOk,
  playFail: playFail,
  playTada: playTada
}

function init(){
  voice.okAudio = new Audio('res/ScanOkSound.wav')
  voice.okAudio.preload = "auto"
  voice.failAudio = new Audio('res/ScanFailSound.wav')
  voice.failAudio.preload = "auto"
  voice.playTadaAudio = new Audio('res/tada.wav')
  voice.playTadaAudio.preload = "auto"
}

/**
 * 播放成功的喜悦
 */
async function playOk(){
  if(voice.okAudio){
    voice.okAudio.currentTime = 0
    await voice.okAudio.play().catch(err => console.warn('[voice] playOk failed:', err))
  }
}

/**
 * 播放失败的悲鸣
 */
async function playFail(){
  if(voice.failAudio){
    voice.failAudio.currentTime = 0
    await voice.failAudio.play().catch(err => console.warn('[voice] playFail failed:', err))
  }
}

async function playTada(){
  if(voice.playTadaAudio){
    voice.playTadaAudio.currentTime = 0
    await voice.playTadaAudio.play().catch(err => console.warn('[voice] playTada failed:', err))
  }
}

export default voice